import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';

// import Schemas
import { Divider, Stack, Typography } from '@mui/material';
import Schema from 'src/lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;

const VNErklaerung: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Erklärungen für Mittelabruf und Verwendungsnachweis' description={PLATZHALTER_TEXT} />

			<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
				Erklärungen für Mittelabruf
			</Typography>
			<Divider />

			<Stack sx={{ mt: '2rem', mb: '2rem' }}>
				<Typography>
					Hiermit bestätige(n) ich/wir, als Antragstellende(r), die Richtigkeit der Angaben in den eingereichten Unterlagen und gebe(n) die
					nachfolgende Erklärung ab:
				</Typography>

				<CreateForm
					formValues={application}
					formStruc={formstrucErklaerungenMA()}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={readOnly}
				/>
			</Stack>

			<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
				Erklärungen für Verwendungsnachweis
			</Typography>
			<Divider />

			<Stack sx={{ mt: '2rem', mb: '2rem' }}>
				<CreateForm
					formValues={application}
					formStruc={formstrucErklaerungenVN()}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={readOnly}
				/>
			</Stack>
		</>
	);
};
export default VNErklaerung;

const formstrucErklaerungenMA = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Erklaerungen_Mittelabruf_Erklaerungen_Block_1_Zelle_1, type: 'checkbox', validation: [{ validateFunction: ForceTrue }] },
				{ ...P.Erklaerungen_Mittelabruf_Erklaerungen_Block_2_Zelle_1, type: 'checkbox', validation: [{ validateFunction: ForceTrue }] },
				{ ...P.Erklaerungen_Mittelabruf_Erklaerungen_Block_3_Zelle_1, type: 'checkbox', validation: [{ validateFunction: ForceTrue }] },
				{ ...P.Erklaerungen_Mittelabruf_Erklaerungen_Block_4_Zelle_1, type: 'checkbox', validation: [{ validateFunction: ForceTrue }] },
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const formstrucErklaerungenVN = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Erklaerungen_Verwendungsnachweis_Erklaerungen_Block_1_Zelle_1, type: 'checkbox', validation: [{ validateFunction: ForceTrue }] },
				{ ...P.Erklaerungen_Verwendungsnachweis_Erklaerungen_Block_2_Zelle_1, type: 'checkbox', validation: [{ validateFunction: ForceTrue }] },
				{ ...P.Erklaerungen_Verwendungsnachweis_Erklaerungen_Block_3_Zelle_1, type: 'checkbox', validation: [{ validateFunction: ForceTrue }] },
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucVNErklaerung = () => {
	return concat(formstrucErklaerungenMA(), formstrucErklaerungenVN());
};
